import apiClient from "../lib/api-client";

export type ReorderPriority = "CRITICAL" | "HIGH" | "MEDIUM" | "LOW";

export interface ReorderSuggestion {
  productId: string;
  productName: string;
  sku: string;
  currentStock: number;
  minStockLevel: number;
  maxStockLevel: number;
  avgDailySales: number;
  normalDailySales: number;
  recentDailySales: number;
  daysOfStockLeft: number;
  demandSpikeMultiplier: number;
  emergencyReorder: boolean;
  suggestedQty: number;
  priority: ReorderPriority;
  lastPurchasePrice: number;
  estimatedCost: number;
  preferredSupplier?: { id: string; name: string };
  category?: { id: string; name: string };
}

export interface DeadStockItem {
  productId: string;
  productName: string;
  sku: string;
  currentStock: number;
  stockValue: number;
  lastSaleDate: string | null;
  daysSinceLastSale: number | null;
  category?: { id: string; name: string };
}

export interface AbcVedAnalysisItem {
  productId: string;
  productName: string;
  sku: string;
  annualConsumptionValue: number;
  annualQuantitySold: number;
  currentStock: number;
  abcClass: "A" | "B" | "C";
  vedClass: "V" | "E" | "D";
  cumulativeValuePercent: number;
  category?: { id: string; name: string };
}

export const reorderService = {
  async getSuggestions(params?: {
    lookbackDays?: number;
    supplierId?: string;
    storeId?: string;
    priority?: ReorderPriority;
  }): Promise<ReorderSuggestion[]> {
    const response = await apiClient.get("/reorder/suggestions", { params });
    return response.data;
  },

  async getDeadStock(params?: {
    days?: number;
    storeId?: string;
  }): Promise<DeadStockItem[]> {
    const response = await apiClient.get("/reorder/dead-stock", { params });
    return response.data;
  },

  async getAbcVedAnalysis(params?: {
    lookbackDays?: number;
    storeId?: string;
  }): Promise<AbcVedAnalysisItem[]> {
    const response = await apiClient.get("/reorder/abc-ved", { params });
    return response.data;
  },

  async generatePurchaseOrder(data: {
    suggestions: Array<{ productId: string; qty: number }>;
    supplierId: string;
    storeId: string;
  }) {
    const response = await apiClient.post("/reorder/generate-po", data, {
      headers: { "Idempotency-Key": crypto.randomUUID() },
    });
    return response.data;
  },
};
